import React,{useState, useEffect} from "react";
import { SingleBanner, YearlyCounts, Information, Environment } from ".";

function LandingPage(e) {
  
  return (
    
    <div className="">
      <div
        className="header-decoration"
        style={{ backgroundColor: "#efefef" }}
      />
      <SingleBanner />
      <YearlyCounts />
      <Information />
      <Environment />
    </div>
    
  );
}

export default LandingPage;
